module.exports = __webpack_public_path__ + "img/user-2-line.f41b35be.svg";